import { render, staticRenderFns } from "./form-reallocations.vue?vue&type=template&id=09063808&scoped=true"
import script from "./form-reallocations.vue?vue&type=script&lang=js"
export * from "./form-reallocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09063808",
  null
  
)

export default component.exports